import api from '../services/api';
import { IProfessional } from '../shared/interfaces';

export interface IPublicProfessional {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  cell_phone?: string;
  specialty_id?: string;
}

interface IResponseGetProfessionals {
  data: IProfessional[];
  count: number;
}

export const getProfessionals = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetProfessionals> => {
  const response = await api.post('/professionals/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const getProfessional = async (
  id: string | undefined,
): Promise<IProfessional> => {
  if (!id) {
    throw new Error('ID do profissional não fornecido.');
  }
  const response = await api.get(`/professionals/${id}`);
  return response.data;
};

export const postProfessional = async (
  payload: any,
): Promise<IProfessional> => {
  const response = await api.post('/professionals', payload);
  return response.data;
};

export const patchProfessional = async (
  id: string | undefined,
  payload: any,
): Promise<IProfessional> => {
  if (!id) {
    throw new Error('ID do profissional não fornecido.');
  }
  const response = await api.patch(`/professionals/${id}`, payload);
  return response.data;
};

export const getSelectProfessionals = async (): Promise<IProfessional[]> => {
  const response = await api.get(`/professionals/select`);
  return response.data;
};

export const getPublicProfessionals = async (): Promise<
  IPublicProfessional[]
> => {
  const response = await api.get('/professionals/public/list');
  return response.data;
};

export const pathProfissionalSignature = async (
  id: string | undefined,
  payload: any,
): Promise<void> => {
  const response = await api.patch(`/professionals/signature/${id}`, payload);
  return response.data;
};

export const pathProfessionalResetPassword = async (
  id: string | undefined,
): Promise<void> => {
  if (!id) {
    throw new Error('ID do profissional não fornecido.');
  }
  const response = await api.patch(
    `/professionals/reset_signature_password/${id}`,
  );
  return response.data;
};

export const pathProfessionalClearSignature = async (
  id: string | undefined,
): Promise<void> => {
  if (!id) {
    throw new Error('ID do profissional não fornecido.');
  }

  const response = await api.patch(`/professionals/clear_signature/${id}`, {});

  return response.data;
};
